import React from 'react';
import RichTextEditor from './RichTextEditor';

function AcademicsEditor({ pageContent, setPageContent, addTableRow, deleteTableRow, updateTableRow }) {
  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>📚 Academics Page</h3>
        
        <div className="form-group">
          <label>Page Title</label>
          <input 
            value={pageContent.title || 'Academics'} 
            onChange={(e) => setPageContent({...pageContent, title: e.target.value})} 
            className="form-input" 
          />
        </div>
        
        <div className="form-group">
          <label>Page Subtitle</label>
          <input 
            value={pageContent.subtitle || 'Excellence in Education'} 
            onChange={(e) => setPageContent({...pageContent, subtitle: e.target.value})} 
            className="form-input" 
          />
        </div>
        
        <div className="form-group">
          <label>Page Description (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.description || ''}
            onChange={(html) => setPageContent({...pageContent, description: html})}
            placeholder="Write about academics here..."
            imageFolder="academics-description-images"
          />
        </div>
        
        <h4>📊 Academic Statistics</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Total Students</label>
            <input 
              type="text" 
              value={pageContent.totalStudents || '5000+'} 
              onChange={(e) => setPageContent({...pageContent, totalStudents: e.target.value})} 
              placeholder="e.g., 5000+" 
              className="form-input" 
            />
          </div>
          <div className="form-group">
            <label>Total Teachers</label>
            <input 
              type="text" 
              value={pageContent.totalTeachers || '200+'} 
              onChange={(e) => setPageContent({...pageContent, totalTeachers: e.target.value})} 
              placeholder="e.g., 200+" 
              className="form-input" 
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>Years of Excellence</label>
            <input 
              type="text" 
              value={pageContent.yearsOfExcellence || '30+'} 
              onChange={(e) => setPageContent({...pageContent, yearsOfExcellence: e.target.value})} 
              placeholder="e.g., 30+ Years" 
              className="form-input" 
            />
          </div>
          <div className="form-group">
            <label>Pass Rate (%)</label>
            <input 
              type="text" 
              value={pageContent.passRate || '98%'} 
              onChange={(e) => setPageContent({...pageContent, passRate: e.target.value})} 
              placeholder="e.g., 98%" 
              className="form-input" 
            />
          </div>
        </div>

        <h4>🎯 Academic Highlights / Features</h4>
        <div className="form-group">
          <label>Show Academic Highlights Section?</label>
          <select 
            value={pageContent.showHighlights || 'yes'} 
            onChange={(e) => setPageContent({...pageContent, showHighlights: e.target.value})} 
            className="form-input"
          >
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>Highlights Title</label>
          <input 
            value={pageContent.highlightsTitle || 'Academic Highlights'} 
            onChange={(e) => setPageContent({...pageContent, highlightsTitle: e.target.value})} 
            className="form-input" 
          />
        </div>
        
        {(pageContent.academicHighlights || []).map((highlight, idx) => (
          <div key={idx} style={{border:'1px solid #e2e8f0', padding:15, marginBottom:15, borderRadius:8, position: 'relative'}}>
            <button 
              className="remove-btn" 
              onClick={() => {
                const newHighlights = (pageContent.academicHighlights || []).filter((_, i) => i !== idx);
                setPageContent({...pageContent, academicHighlights: newHighlights});
              }}
              style={{position: 'absolute', top: 10, right: 10}}
            >
              🗑️ Delete
            </button>
            
            <div className="form-group">
              <label>Icon (emoji or text)</label>
              <input 
                placeholder="e.g., 🎓, 📚, 🏆" 
                value={highlight.icon || '📚'} 
                onChange={(e) => {
                  const newHighlights = [...(pageContent.academicHighlights || [])];
                  newHighlights[idx].icon = e.target.value;
                  setPageContent({...pageContent, academicHighlights: newHighlights});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Title</label>
              <input 
                placeholder="Highlight Title" 
                value={highlight.title || ''} 
                onChange={(e) => {
                  const newHighlights = [...(pageContent.academicHighlights || [])];
                  newHighlights[idx].title = e.target.value;
                  setPageContent({...pageContent, academicHighlights: newHighlights});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Description (Rich Text)</label>
              <RichTextEditor 
                value={highlight.description || ''}
                onChange={(html) => {
                  const newHighlights = [...(pageContent.academicHighlights || [])];
                  newHighlights[idx].description = html;
                  setPageContent({...pageContent, academicHighlights: newHighlights});
                }}
                placeholder="Write highlight description..."
                imageFolder="academics-highlight-images"
              />
            </div>
          </div>
        ))}
        
        <button className="add-btn" onClick={() => addTableRow('academicHighlights', { icon: '📚', title: 'New Highlight', description: '' })}>
          + Add Academic Highlight
        </button>

        <h4>📖 Academic Programs</h4>
        <div className="form-group">
          <label>Show Academic Programs Section?</label>
          <select 
            value={pageContent.showPrograms || 'yes'} 
            onChange={(e) => setPageContent({...pageContent, showPrograms: e.target.value})} 
            className="form-input"
          >
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>Programs Title</label>
          <input 
            value={pageContent.programsTitle || 'Academic Programs'} 
            onChange={(e) => setPageContent({...pageContent, programsTitle: e.target.value})} 
            className="form-input" 
          />
        </div>
        
        {(pageContent.academicPrograms || []).map((program, idx) => (
          <div key={idx} style={{border:'1px solid #e2e8f0', padding:15, marginBottom:15, borderRadius:8, position: 'relative'}}>
            <button 
              className="remove-btn" 
              onClick={() => {
                const newPrograms = (pageContent.academicPrograms || []).filter((_, i) => i !== idx);
                setPageContent({...pageContent, academicPrograms: newPrograms});
              }}
              style={{position: 'absolute', top: 10, right: 10}}
            >
              🗑️ Delete
            </button>
            
            <div className="form-group">
              <label>Program Name</label>
              <input 
                placeholder="e.g., Primary School, Middle School, High School" 
                value={program.name || ''} 
                onChange={(e) => {
                  const newPrograms = [...(pageContent.academicPrograms || [])];
                  newPrograms[idx].name = e.target.value;
                  setPageContent({...pageContent, academicPrograms: newPrograms});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Grades</label>
              <input 
                placeholder="e.g., Grades 1-5" 
                value={program.grades || ''} 
                onChange={(e) => {
                  const newPrograms = [...(pageContent.academicPrograms || [])];
                  newPrograms[idx].grades = e.target.value;
                  setPageContent({...pageContent, academicPrograms: newPrograms});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Description (Rich Text)</label>
              <RichTextEditor 
                value={program.description || ''}
                onChange={(html) => {
                  const newPrograms = [...(pageContent.academicPrograms || [])];
                  newPrograms[idx].description = html;
                  setPageContent({...pageContent, academicPrograms: newPrograms});
                }}
                placeholder="Write program description..."
                imageFolder="academics-program-images"
              />
            </div>
            
            <div className="form-group">
              <label>Key Features (Comma separated)</label>
              <input 
                placeholder="e.g., Smart Classes, Sports, Library" 
                value={program.features || ''} 
                onChange={(e) => {
                  const newPrograms = [...(pageContent.academicPrograms || [])];
                  newPrograms[idx].features = e.target.value;
                  setPageContent({...pageContent, academicPrograms: newPrograms});
                }} 
                className="form-input" 
              />
            </div>
          </div>
        ))}
        
        <button className="add-btn" onClick={() => addTableRow('academicPrograms', { name: '', grades: '', description: '', features: '' })}>
          + Add Academic Program
        </button>

        <h4>🔗 Academic Links (Editable Cards)</h4>
        <small style={{display: 'block', marginBottom: '10px', color: '#64748b'}}>
          Add, edit, or remove academic resource links. Each link will appear as a card with icon, features, and explore button.
        </small>
        
        {(pageContent.academicLinks || []).map((link, idx) => (
          <div key={idx} style={{border:'1px solid #e2e8f0', padding:15, marginBottom:15, borderRadius:8, position: 'relative'}}>
            <button 
              className="remove-btn" 
              onClick={() => {
                const newLinks = (pageContent.academicLinks || []).filter((_, i) => i !== idx);
                setPageContent({...pageContent, academicLinks: newLinks});
              }}
              style={{position: 'absolute', top: 10, right: 10}}
            >
              🗑️ Delete
            </button>
            
            <div className="form-group">
              <label>Link Name</label>
              <input 
                placeholder="e.g., Curriculum, Syllabus, Time Table" 
                value={link.name || ''} 
                onChange={(e) => {
                  const newLinks = [...(pageContent.academicLinks || [])];
                  newLinks[idx].name = e.target.value;
                  setPageContent({...pageContent, academicLinks: newLinks});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Icon (emoji)</label>
              <input 
                placeholder="e.g., 📖, 📋, 📝" 
                value={link.icon || '📚'} 
                onChange={(e) => {
                  const newLinks = [...(pageContent.academicLinks || [])];
                  newLinks[idx].icon = e.target.value;
                  setPageContent({...pageContent, academicLinks: newLinks});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Path / URL</label>
              <input 
                placeholder="e.g., /curriculum, /syllabus" 
                value={link.path || ''} 
                onChange={(e) => {
                  const newLinks = [...(pageContent.academicLinks || [])];
                  newLinks[idx].path = e.target.value;
                  setPageContent({...pageContent, academicLinks: newLinks});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Description (Rich Text)</label>
              <RichTextEditor 
                value={link.description || ''}
                onChange={(html) => {
                  const newLinks = [...(pageContent.academicLinks || [])];
                  newLinks[idx].description = html;
                  setPageContent({...pageContent, academicLinks: newLinks});
                }}
                placeholder="Write link description..."
                imageFolder="academics-link-images"
              />
            </div>
            
            <div className="form-group">
              <label>Features (Comma separated)</label>
              <input 
                placeholder="e.g., CBSE Curriculum, Experienced Teachers, Smart Classes" 
                value={link.features || ''} 
                onChange={(e) => {
                  const newLinks = [...(pageContent.academicLinks || [])];
                  newLinks[idx].features = e.target.value;
                  setPageContent({...pageContent, academicLinks: newLinks});
                }} 
                className="form-input" 
              />
            </div>
          </div>
        ))}
        
        <button className="add-btn" onClick={() => addTableRow('academicLinks', { 
          name: 'New Section', 
          path: '/new-page', 
          icon: '📚', 
          description: '', 
          features: '' 
        })}>
          + Add Academic Link
        </button>
        
        <div className="form-group">
          <label>Default Academic Links (Pre-populated)</label>
          <small style={{display: 'block', marginBottom: '10px', color: '#64748b'}}>
            These are the default links that will appear if no custom links are added.
          </small>
          <div style={{background: '#f8fafc', padding: '15px', borderRadius: '8px'}}>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px'}}>
              <div><strong>📖 Curriculum</strong> → /curriculum</div>
              <div><strong>📋 Syllabus</strong> → /syllabus</div>
              <div><strong>📝 Question Papers</strong> → /question-papers</div>
              <div><strong>🎒 Holiday Homework</strong> → /holiday-homework</div>
              <div><strong>⏰ Time Table</strong> → /time-table</div>
              <div><strong>📅 Academic Calendar</strong> → /calendar</div>
              <div><strong>👨‍🏫 Teachers & Staff</strong> → /teachers</div>
              <div><strong>⚖️ Mandatory Disclosure</strong> → /mandatory-disclosure</div>
            </div>
          </div>
        </div>

        <h4>📊 Results & Achievements Section</h4>
        <div className="form-group">
          <label>Show Results Section?</label>
          <select 
            value={pageContent.showResults || 'yes'} 
            onChange={(e) => setPageContent({...pageContent, showResults: e.target.value})} 
            className="form-input"
          >
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>Results Title</label>
          <input 
            value={pageContent.resultsTitle || 'Board Exam Results'} 
            onChange={(e) => setPageContent({...pageContent, resultsTitle: e.target.value})} 
            className="form-input" 
          />
        </div>
        
        <div className="form-group">
          <label>Results Description (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.resultsDescription || ''}
            onChange={(html) => setPageContent({...pageContent, resultsDescription: html})}
            placeholder="Write about exam results..."
            imageFolder="academics-results-images"
          />
        </div>
        
        {(pageContent.results || []).map((result, idx) => (
          <div key={idx} style={{border:'1px solid #e2e8f0', padding:15, marginBottom:15, borderRadius:8, position: 'relative'}}>
            <button 
              className="remove-btn" 
              onClick={() => {
                const newResults = (pageContent.results || []).filter((_, i) => i !== idx);
                setPageContent({...pageContent, results: newResults});
              }}
              style={{position: 'absolute', top: 10, right: 10}}
            >
              🗑️ Delete
            </button>
            
            <div className="form-group">
              <label>Year</label>
              <input 
                placeholder="e.g., 2024" 
                value={result.year || ''} 
                onChange={(e) => {
                  const newResults = [...(pageContent.results || [])];
                  newResults[idx].year = e.target.value;
                  setPageContent({...pageContent, results: newResults});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Pass Percentage</label>
              <input 
                placeholder="e.g., 98%" 
                value={result.percentage || ''} 
                onChange={(e) => {
                  const newResults = [...(pageContent.results || [])];
                  newResults[idx].percentage = e.target.value;
                  setPageContent({...pageContent, results: newResults});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Total Students</label>
              <input 
                placeholder="e.g., 500" 
                value={result.totalStudents || ''} 
                onChange={(e) => {
                  const newResults = [...(pageContent.results || [])];
                  newResults[idx].totalStudents = e.target.value;
                  setPageContent({...pageContent, results: newResults});
                }} 
                className="form-input" 
              />
            </div>
            
            <div className="form-group">
              <label>Remarks (Rich Text)</label>
              <RichTextEditor 
                value={result.remarks || ''}
                onChange={(html) => {
                  const newResults = [...(pageContent.results || [])];
                  newResults[idx].remarks = html;
                  setPageContent({...pageContent, results: newResults});
                }}
                placeholder="Additional remarks..."
                imageFolder="academics-result-images"
              />
            </div>
          </div>
        ))}
        
        <button className="add-btn" onClick={() => addTableRow('results', { year: '', percentage: '', totalStudents: '', remarks: '' })}>
          + Add Result
        </button>
      </div>

      <style>{`
        .page-editor {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .editor-card {
          background: #fff;
          border-radius: 16px;
          padding: 24px;
          margin-bottom: 24px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        
        .editor-card h3 {
          margin: 0 0 8px;
          color: #1a3a6b;
          font-size: 24px;
        }
        
        .editor-card h4 {
          margin: 24px 0 16px;
          color: #1a3a6b;
          font-size: 20px;
          border-bottom: 2px solid #e2e8f0;
          padding-bottom: 8px;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          color: #334155;
          font-size: 14px;
        }
        
        .form-input {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #cbd5e1;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.3s;
        }
        
        .form-input:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59,130,246,0.1);
        }
        
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
        
        .add-btn {
          background: #10b981;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          font-size: 14px;
          transition: background 0.3s;
        }
        
        .add-btn:hover {
          background: #059669;
        }
        
        .remove-btn {
          background: #ef4444;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
          transition: background 0.3s;
        }
        
        .remove-btn:hover {
          background: #dc2626;
        }
        
        @media (max-width: 768px) {
          .editor-card {
            padding: 16px;
          }
          
          .form-row {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          
          .editor-card h3 {
            font-size: 20px;
          }
          
          .editor-card h4 {
            font-size: 18px;
          }
        }
      `}</style>
    </div>
  );
}

export default AcademicsEditor;